// extracted by mini-css-extract-plugin
export default {"wrapper":"My0O1m","dropdown":"BB_sDo","floatingDropdown":"yCDWhG","divider":"YA45wW","tabs":"YQtAP8","cart-button":"Bc6FQT","cartButton":"Bc6FQT"};